import { ParsedUrlQuery } from 'querystring';

import { MappedFilter } from '@components/SearchController/SearchController.utils';

export const checkNestedFilters = (filters: MappedFilter[], initialValues: ParsedUrlQuery): boolean =>
  filters
    .flatMap(({ key, nodes = [] }) => [initialValues[key] || checkNestedFilters(nodes, initialValues) || []].flat())
    .some(Boolean);

export const getFormValues = (elements?: HTMLFormControlsCollection): Record<string, string[]> => {
  const formData: { key: string; value: string }[] = [].filter
    .call(
      elements || [],
      (element: HTMLInputElement) =>
        element.name && (element.type !== 'checkbox' || (element.type === 'checkbox' && element.checked))
    )
    .map((element: HTMLInputElement) => ({ key: element.name, value: element.value }));
  return formData.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.key]: acc[curr.key] ? [...acc[curr.key], curr.value] : [curr.value],
    }),
    {} as Record<string, string[]>
  );
};
